import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-5",
  "use": "menu-5-usage",
  "viewBox": "0 0 36.99 43.2",
  "content": "<symbol viewBox=\"0 0 36.99 43.2\" id=\"menu-5\"><defs><style>#menu-5 .cls-1{opacity:0.2;}</style></defs><title>资源 11</title><g id=\"menu-5_图层_2\" data-name=\"图层 2\"><g id=\"menu-5_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M2.94,43.2H36.73L34.37,16.7,23,29.27,15.87,23.2,3,35.6l-.8,1.11Zm0,0\" /><path d=\"M34.14,16.63h2.78V43.2H34.14ZM23,29.17H25.8v14H23ZM11.6,27.44h2.78V43.2H11.6ZM.19,35.6H3v7.6H.19ZM37,0,25.77,2.62l3.64,3.56-10.06,11-5.05-5L0,26.46l2,2L14.31,16.08l5.14,5.06,11.95-13,3.69,3.61Zm0,0\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-5.svg
// module id = 8u6G
// module chunks = 264